module.exports = __webpack_public_path__ + "static/software_update_page-7ef559376934bd99c19da6bbd67323c1.webp";